import axios from "axios";
import axiosRetry from "axios-retry";

export function requeryContainerStatus(token: string, projectId: string, modelId: string) {
  const instance = axios.create({
    baseURL: process.env.NODE_ENV === "production"
      ? 'https://deploy.blankly.finance'
      : `${process.env.NEXT_PUBLIC_URL_DEPLOYMENT_API}`,
    headers: {
      token: token,
    },
  });

  axiosRetry(instance, {retryDelay: axiosRetry.exponentialDelay});

  return instance.post('/model/status', {
    projectId: projectId,
    modelId: modelId,
  })
}
